import { gql } from '@apollo/client';

const TASK_MARK_COMPLETE = gql`
  mutation TaskMarkComplete($input: TaskMarkCompleteInput!) {
    taskMarkComplete(input: $input) {
      errors {
        error
        message
      }
      taskList {
        __typename
        id
        tasksCount
        tasksCompletedCount
      }
      task {
        __typename
        id
        completed
        completedAt
        completedBy {
          id
          name
          company {
            id
            name
            avatar
            accentColor
          }
        }
      }
    }
  }
`;

export default TASK_MARK_COMPLETE;
